module.exports = __webpack_public_path__ + "media/重阳节.31833473.mp3";